import styled from "@emotion/styled";
import { css } from "@emotion/react";
import {
	LengthValue,
	StyledCompactCardSelect,
	StyledGrid,
	StyledScrollContainer,
} from "@animech/ui";

export const CustomProductList = styled.div`
	${() => {
		const sideMargin: LengthValue = "16px";

		return css`
			> div {
				max-width: unset;
			}

			${StyledScrollContainer.ScrollContainer} {
				margin: 0;

				${StyledScrollContainer.Scroller} {
					${StyledScrollContainer.Content} {
						display: grid;
						grid-auto-flow: row;
						grid-auto-rows: var(--card-width);
						gap: 26px;

						[draggable="true"] {
							touch-action: pan-x;
							margin: 0;
						}

						*:not(:last-child) {
							${StyledCompactCardSelect.Root} {
								${StyledCompactCardSelect.LabelContainer} {
									border-bottom: 1px solid #d0d0d0;
								}
							}
						}
					}
				}
			}
			${StyledGrid.Grid} {
				max-width: calc(100% - ${sideMargin});
				display: grid;
				grid-template-columns: repeat(auto-fit, var(--card-width));
				margin: 0 ${sideMargin};
				padding-bottom: 12px;
				max-height: calc(100% - 12px);
			}
		`;
	}}
`;
